import React, { useEffect, useState } from "react";
import '../scss/task.scss';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { connect, useSelector } from "react-redux";
import { editPurchaseOrder, getProject, getProjectList, getPurchaseOrder, savePurchaseOrder } from "../../../actions/project-management.action";
import { getProjectCustomer } from "../../../actions/invoice.action";
import { resolveProjectType } from "../utils/resolve-project-type";
import { getVendorList } from "../../../actions/vendor-management.action";
import { warningSnackBar, successSnackBar } from "../../../actions/common.action";
import { PROJECT_MANAGEMENT } from "../../../constants/route-paths";
import CreatePOComponent from "../../../components/po/create";
import { bindActionCreators } from "redux";
import { getGlobalSetting } from "../../../actions/global-setting.action";
import { getCustomerSiteAddress, getCustomer } from "../../../actions/customer-management.action";
import { getInventoryLists } from "../../../actions/inventory.action";
import { getUserList } from "../../../actions/user-management.action";
import idx from "idx";

const CreatePurchaseOrder = (props) => {
  const { projectId, poId } = useParams();
  let [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const [projectType, setProjectType] = useState("");
  const [projectName, setProjectName] = useState("");
  const projectState = useSelector(state => state.project);

  useEffect(() => {
    fetchData();
  }, [projectId]);

  const fetchData = async () => {
    if (projectId) {
      let pName = idx(props.projectSummary, _ => _.project.projectName);
      let pType = searchParams.get("project-type") || idx(props.projectSummary, _ => _.project.projectType);

      if (!pName) {
        try {
          const res = await props.getProjectCustomer(projectId);
          if (res) {
            pName = res.name;
            if (!pType) {
              pType = res.projectType;
            }
          }
        } catch (e) {
          console.error(e);
        }
      }
      const resolvedType = resolveProjectType(pType, projectState);
      setProjectType(resolvedType);
      setProjectName(pName || '');
    }
  };

  const viewPoList = () => navigate(`/${PROJECT_MANAGEMENT}/purchase-order/${projectId}`);
  const viewProject = () => navigate(`/projects/view/${projectId}`);
  const viewProjectList = () => {
    let type = resolveProjectType(searchParams.get("project-type") || projectType, projectState);
    navigate(`/projects?project-type=${type}`);
  }

  return (
    <>
      <CreatePOComponent
        breadcrumb={
          <Breadcrumb>
            <Breadcrumb.Item onClick={viewProjectList}>PROJECTS</Breadcrumb.Item>
            <Breadcrumb.Item onClick={viewProject}>{projectName}</Breadcrumb.Item>
            <Breadcrumb.Item onClick={viewPoList}>PO LIST</Breadcrumb.Item>
            <Breadcrumb.Item active>{poId ? 'Edit Purchase Order' : 'Create Purchase Order'}</Breadcrumb.Item>
          </Breadcrumb>
        }
        projectId={projectId}
        cancelHandler={viewPoList}
        warningSnackBar={props.warningSnackBar}
        successSnackBar={props.successSnackBar}
        getProject={props.getProject}
        getProjectList={props.getProjectList}
        savePurchaseOrder={props.savePurchaseOrder}
        editPurchaseOrder={props.editPurchaseOrder}
        getVendorList={props.getVendorList}
        getPurchaseOrder={props.getPurchaseOrder}
        getGlobalSetting={props.getGlobalSetting}
        getCustomerSiteAddress={props.getCustomerSiteAddress}
        getCustomer={props.getCustomer}
        getUserList={props.getUserList}
        getInventoryItems={props.getInventoryLists}
      />
    </>
  );
};

const mapStateToProps = (state) => ({
  projectSummary: state.projectSummary,
});

const mapDispatchToProps = (dispatch) => ({
  warningSnackBar: bindActionCreators(warningSnackBar, dispatch),
  successSnackBar: bindActionCreators(successSnackBar, dispatch),
  getProjectList: bindActionCreators(getProjectList, dispatch),
  savePurchaseOrder: bindActionCreators(savePurchaseOrder, dispatch),
  editPurchaseOrder: bindActionCreators(editPurchaseOrder, dispatch),
  getVendorList: bindActionCreators(getVendorList, dispatch),
  getProject: bindActionCreators(getProject, dispatch),
  getPurchaseOrder: bindActionCreators(getPurchaseOrder, dispatch),
  getGlobalSetting: bindActionCreators(getGlobalSetting, dispatch),
  getCustomerSiteAddress: bindActionCreators(getCustomerSiteAddress, dispatch),
  getCustomer: bindActionCreators(getCustomer, dispatch),
  getUserList: bindActionCreators(getUserList, dispatch),
  getInventoryLists: bindActionCreators(getInventoryLists, dispatch),
  getProjectCustomer: bindActionCreators(getProjectCustomer, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(CreatePurchaseOrder);